import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import env from '../../../package.json';

import * as Styled from './styles';

export interface IDisclaimer {
  title?: string;
  onAccept?: () => void;
  onCheck?: (value: boolean) => void;
}

export function Disclaimer({ title, onAccept }: IDisclaimer) {
  const [isDisabled, setIsDisabled] = useState(false);

  const { t: translation } = useTranslation();

  return createPortal(
    <Styled.BackgroundBlur>
      <Styled.DisclaimerBlock isDisabled={isDisabled}>
        {title && <h1>{title}</h1>}
        <div className="contentBlock">
          <div>
            <p>
              A Plataforma de Suporte à Pesquisa e Produção Mineral (P3M) foi concebida e vem sendo implementada por uma equipe de especialistas da Diretoria de Geologia e Recursos Minerais (DGM) 
              do Serviço Geológico do Brasil (SGB). O processo de concepção e implementação da P3M conta com o apoio e participação da Secretaria de Geologia, Mineração e Transformação Mineral (SGM) 
              do Ministério de Minas e Energia (MME) e da Agência Nacional de Mineração (ANM). Conta também com o apoio e participação de entidades públicas e privadas relacionadas, direta ou indiretamente, 
              à indústria mineral brasileira, tais como:
            </p>
            <ul>
              <li>Agência para o Desenvolvimento e Inovação do Setor Mineral Brasileiro (ADIMB),</li>
              <li>Associação Brasileira das Empresas de Pesquisa Mineral e Mineração (ABPM),</li>
              <li>Associação Nacional das Entidades de Produtores de Agregados para Construção (ANEPAC),</li>
              <li>Instituto Brasileiro de Geografia e Estatística (IBGE),</li>
              <li>Instituto Brasileiro de Mineração (IBRAM),</li>
              <li>Agência UFLA de Inovação, Geotecnologia e Sistemas Inteligentes (Zetta).</li>
            </ul>
            <p>
              A implantação do P3M está sendo realizada pela Agência UFLA de Inovação em Geotecnologias e Sistemas Inteligentes (Zetta), por meio de Termo de Execução Descentralizada (TED) 
              firmado com a Universidade Federal de Lavras (UFLA), sendo o SGB a Unidade Descentralizadora e a UFLA a Unidade Descentralizada. O objetivo do TED é realizar projetos de pesquisa, 
              treinamento, ciência de dados e inovação para a implementação de novas tecnologias voltadas para geologia e recursos minerais.
            </p>
            <p>
              Esta versão {env.version}, atualização da versão beta anterior, apresenta uma nova interface, com um design mais amigável para o usuário e enfoque na visualização geoespacial dos dados, 
              com novas funcionalidades. Além dessas melhorias e inovações, esta versão conta também com um conjunto de camadas ampliado, tanto em termos das informações geradas pelo próprio SGB, 
              como em informações públicas geradas por outras instituições. Importante ressaltar que a P3M continua baseada em software livre.
            </p>
            <p>
              Todos os dados utilizados nesta versão da P3M são públicos, abertos e gratuitos, e encontram-se disponibilizados na internet, pelas respectivas instituições. É importante 
              ressaltar que o SGB não detém qualquer direito autoral ou qualquer responsabilidade sobre os dados das outras instituições, inclusive no que se refere a problemas de 
              integridade que venham a apresentar. Não possui também qualquer responsabilidade relacionada ao uso e interpretação indevidos dos dados publicados na P3M.
            </p>
            <p>
              Além disso, em consonância com a Lei Geral de Proteção dos Dados, os usuários estão livres para navegar na P3M sem nenhum tipo de cadastro. Em relação à política de cookies, 
              caso os usuários autorizem a coleta, serão utilizados para armazenar dados da sessão do usuário na P3M.
            </p>
          </div>
        </div>
        <div className="acceptButton">
          <Button
            onClick={() => {
              onAccept && onAccept();
              setIsDisabled(true);
            }}
            outline
          >
            {translation('disclaimer.buttonText')}
          </Button>
        </div>
      </Styled.DisclaimerBlock>
    </Styled.BackgroundBlur>,
    document.getElementById('modal')!, //eslint-disable-line
  );
}
